import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

export const GET_CLINIC_PARTNERS_MEMBERS_QUERY_KEY = "getClinicPartnersMembers";

const getClinicPartnersMembersQueryKey = () => [GET_CLINIC_PARTNERS_MEMBERS_QUERY_KEY] as const;

export const useGetClinicPartnersMembers = () => {
  const client = useApiClient();

  return useQuery({
    queryKey: getClinicPartnersMembersQueryKey(),
    queryFn: () => client.getClinicPartnersMembers(),
  });
};
